module.exports = __webpack_public_path__ + "img/car_00061.84fc8c11.jpg";